module.exports = __webpack_public_path__ + "img/ic_services_sauna.2f0dfb61.svg";